module.exports = __webpack_public_path__ + "static/media/DSCF0323-lOnoiYgs.9e625f10.JPG";